import { useApiQuery } from '../useApiQuery';
import { apiGet, operationsClient } from '@/lib/api';
import { technicianAnalyticsReportEndpoints } from '@/lib/api/endpoints';

export interface TechnicianOverview {
  totalTechs: number;
  totalJobs: number;
  totalRevenue: number;
  totalHours: number;
  avgUtilization: number;
  revenuePerHour: number;
  membershipsSold: number;
}

export interface TechnicianPerformanceReport {
  period: { from: string; to: string };
  overview: TechnicianOverview;
  overviewPrevious: TechnicianOverview;
}

export function useTechnicianPerformance(
  technicianId: string | undefined,
  range: { from: string; to: string },
) {
  return useApiQuery<TechnicianPerformanceReport>({
    queryKey: ['technician', 'performance', technicianId ?? '', range.from, range.to],
    queryFn: () =>
      apiGet<TechnicianPerformanceReport>(
        operationsClient,
        technicianAnalyticsReportEndpoints.performance({
          technicianId,
          from: range.from,
          to: range.to,
        }),
      ),
    enabled: Boolean(technicianId),
    showErrorToast: false,
  });
}

export interface UpcomingAppointment {
  id: string;
  startAt: string | null;
  endAt: string | null;
  scheduledDate?: string | null;
  timezone: string;
  status: string;
  customerName: string;
  title: string;
  jobId: string | null;
  jobName: string | null;
}

export function useTechnicianAppointments(technicianId: string | undefined, scope?: 'all') {
  return useApiQuery<UpcomingAppointment[]>({
    queryKey: ['technician', 'appointments', technicianId ?? '', scope ?? 'upcoming'],
    queryFn: () =>
      apiGet<UpcomingAppointment[]>(
        operationsClient,
        `/technicians/${technicianId}/appointments`,
        scope ? { params: { scope } } : undefined,
      ),
    enabled: Boolean(technicianId),
    showErrorToast: false,
  });
}
